import { aiJson } from "@/services/ai.service";
import type { Character } from "./characters";

export interface DialogueTurn {
  role: "partner" | "user";
  text: string;
}

export type Mood = "neutral" | "begeistert" | "genervt" | "amuesiert" | "traurig" | "wuetend" | "beeindruckt";

export interface NextTurnResult {
  text: string;
  mood: Mood;
  done: boolean;
}

const RESPONSE_SCHEMA =
  'Antworte NUR mit JSON: {"text":"<dein gesprochener Beitrag, mit Ähm/Pausen>",' +
  '"mood":"<eines von neutral|begeistert|genervt|amuesiert|traurig|wuetend|beeindruckt>",' +
  '"done":<true, wenn das Gespräch nach dieser Bemerkung natürlich enden sollte, sonst false>}.';

/** Nächster Gesprächsbeitrag des Charakters, gegründet auf das eigene Material des Themas. */
export async function nextTurn(opts: {
  character: Character;
  topicTitle: string;
  sourcesText: string;
  history: DialogueTurn[];
}): Promise<NextTurnResult> {
  const system = `${opts.character.systemPrompt}\n\n${RESPONSE_SCHEMA}`;
  // Nur die letzten Beiträge – bei einem langen Gespräch würde der Verlauf
  // sonst zusammen mit dem Material irgendwann Groqs Minuten-Kontingent
  // sprengen (siehe GROQ_SAFE_PROMPT_TOKENS in ai.service.ts).
  const historyText = opts.history
    .slice(-16)
    .map((t) => `${t.role === "partner" ? "Du" : "Nutzer"}: ${t.text}`)
    .join("\n");
  const user =
    `Thema: ${opts.topicTitle}\n\nMaterial (einzige erlaubte Quelle für Fragen/Fakten):\n"""\n` +
    `${opts.sourcesText.slice(0, 8000)}\n"""\n\nBisheriger Gesprächsverlauf:\n` +
    (historyText || "(Das Gespräch startet gerade erst – stell die erste Frage zum Thema.)");
  // 500 Tokens reichten knapp, solange "medium" (Nemotron, ein denkendes
  // Modell) unbegrenzt vor sich hin dachte – das Budget war oft schon vor der
  // eigentlichen JSON-Antwort aufgebraucht (siehe reasoning-Deckel in
  // hooks.pb.js). Etwas Luft zusätzlich, falls einzelne Anfragen trotzdem
  // mehr Denkschritte brauchen.
  return aiJson<NextTurnResult>(system, user, 900, "medium");
}
